export default __webpack_public_path__ + "static/media/IkonNounMoney.de03f81d.svg";